let _controlIsIntersecting = false;
let _controlCallback = null;
let _controlIO = null;
let _controlElement = null;
const CONTROL_ROOT_MARGIN = "0px 0px 2400px 0px";

function controlSentinelIsVisible()
{
    return(_controlIsIntersecting);
}

function controlSetCallback(callback)
{
    _controlCallback = callback;
}

function controlStartUp(controlIdName)
{

    if (_controlIO !== null)
    {
        _controlIO.unobserve(_controlElement);
    } 
    else
    {
        _controlIO = new IntersectionObserver(entries =>
        {
            _controlIsIntersecting = entries[0].isIntersecting;
            if ((_controlCallback !== null) && (_controlIsIntersecting === true))
            {
                // console.log("Control Callback");
                _controlCallback();
                _controlCallback = null;
            }
        },
        {
            rootMargin: CONTROL_ROOT_MARGIN
        });
    }

    _controlElement = document.getElementById(controlIdName);
    _controlIO.observe(_controlElement);
}

export { controlStartUp, controlSentinelIsVisible, controlSetCallback };
